//Handle Parts Table Hide and Show Events
document.addEventListener("DOMContentLoaded", function () {
	//console.log('running the parts table script');
    const partsTables = document.getElementsByClassName("parts-table");

    for (let table of partsTables) {
        const partNumbers = table.querySelectorAll('tr');

		//console.log('number of parts in table', partNumbers.length);
        if (partNumbers.length >= 12) {
            //const showToggle = document.createElement("<p class='cta cta--view-more'><a class='cta__link' href='#'>View <em>More</em> <i class='fa fa-chevron-down' aria-hidden='true'></i></a></p>");
            const iTag = document.createElement("i");
            iTag.classList.add("fa");
            iTag.classList.add("fa-chevron-down");
            iTag.setAttribute("aria-hidden", "true");

            const emTag = document.createElement("em");
            emTag.textContent = "More ";

            const aTag = document.createElement("a");
            aTag.classList.add("cta__link");
            aTag.setAttribute("href", "#");
            aTag.textContent = "View ";
            aTag.appendChild(emTag);
            aTag.appendChild(iTag);

            const showToggle = document.createElement("p");
            showToggle.classList.add("cta");
            showToggle.classList.add("cta--view-more");
            showToggle.appendChild(aTag);

            table.appendChild(showToggle);

            table.querySelector('.cta').addEventListener("click", (event) => {
				event.preventDefault();
                table.classList.toggle('show');
                if (table.classList.contains("show")) {
                    table.querySelector('em').textContent = 'Less ';
                    table.querySelector('i').classList.remove('fa-chevron-down');
                    table.querySelector('i').classList.add('fa-chevron-up');

				} else {
                    table.querySelector('em').textContent = 'More ';
                    table.querySelector('i').classList.remove('fa-chevron-up');
                    table.querySelector('i').classList.add('fa-chevron-down');
				}

			});
		}
	}

});
